import {
  ParticipantFieldCategory,
  useParticipantFieldsCategory,
} from '@app/api';
import { InformationSection } from '../../Profile/components/InformationSection';
import { ParticipantInputByName } from '../../Profile/components/ParticipantInputByName';

export const Personal = () => {
  const categoryConfig = useParticipantFieldsCategory(
    ParticipantFieldCategory.PERSONAL,
  );
  if (!categoryConfig) {
    return null;
  }

  return (
    <InformationSection
      title={categoryConfig.title}
      icon="ri-user-3-line"
      iconColor="blue"
    >
      <ParticipantInputByName fieldName="familyStatus" />
      <ParticipantInputByName fieldName="educationLevel" />
      <ParticipantInputByName fieldName="income" />
      <ParticipantInputByName fieldName="professionalSituation" />
    </InformationSection>
  );
};
